import React, { Component } from "react";
import LayoutPage from "./LayoutIdentificationPages";

class NotAuthorized extends Component {
  render() {
    return (
      <LayoutPage>
        <h1 style={{ width: '100%', textAlign: 'center' }}>
          Vous n’êtes pas autorisé à accéder à cette page
        </h1>
      </LayoutPage>
    );
  }
}

export default NotAuthorized;
